import React from 'react';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import Typography from "@mui/material/Typography";
import { BUSINESS_NAME, contactDetails } from "@/content";
import { useTheme } from '@mui/material/styles';
import Box from "@mui/material/Box";


type ContactMethod = {
    icon: React.ElementType;
    heading: string;
    link: (value: string) => string;
    value: string | undefined;
    additionalValue?: string;
};

const ContactUsBlock = () => {
    const { contactEmail, contactNumberOne, contactNumberTwo } = contactDetails;
    const theme = useTheme();

    const contactMethods : ContactMethod[] = [
        {
            icon: PhoneAndroidIcon,
            heading: "Phone",
            link: (value: string) => `tel:${value}`,
            value: contactNumberOne,
            additionalValue: contactNumberTwo,
        },
        {
            icon: SmsIcon,
            heading: "SMS",
            link: (value: string) => `sms:${value}`,
            value: contactNumberOne,
            additionalValue: contactNumberTwo,
        },
        {
            icon: EmailIcon,
            heading: "Email",
            link: (value: string) => `mailto:${value}`,
            value: contactEmail,
        },
    ];

    return (
        <div className="flex flex-wrap gap-8 justify-around items-start">
            <div>
                <Typography variant="h4" component="h3" align="center" className=" mb-4 underline pb-10 text-center w-[100%]">
                    Contact {BUSINESS_NAME}
                </Typography>
                <div className="flex flex-wrap justify-around items-start gap-[40px]">
                    {contactMethods.map((method, index) => (
                        method.value && (
                            <Box
                                className="grid text-center p-5  max-sm:h-[250px] max-sm:w-[250px] max-sm:bg-white max-sm:rounded-full items-center expand-in-out fade-in"
                                key={index}
                                sx={(theme) =>({
                                    [theme.breakpoints.down('sm')]: {
                                        border: `1px solid ${theme.palette.secondary.main}`,
                                    },
                                })}
                            >

                                    <div className="flex flex-col items-center text-center gap-2">
                                        <div className="text-gray-700" style={{ color: theme.palette.primary.main }}>
                                            <method.icon fontSize="large" color="inherit"/>
                                        </div>
                                        <div className="font-medium">{method.heading}</div>
                                        <div className="text-md text-blue-500 hover:underline" >
                                            <a href={method.link(method.value)}>{method.value}</a>
                                            {method.additionalValue && (
                                                <span>
                                            {' '}OR{' '}
                                                    <a href={method.link(method.additionalValue)}
                                                       className="hover:underline">
                                                {method.additionalValue}
                                            </a>
                                        </span>
                                            )}
                                        </div>
                                    </div>
                                </Box>
                                )
                                ))}
                            </div>
                        </div>
                        </div>
                        );
                    };

                    export default ContactUsBlock;
